// extracted by mini-css-extract-plugin
export default {"ZoomerImage":"ZoomerImage-module__ZoomerImage___2obWq","defaultScale":"ZoomerImage-module__defaultScale___1GY64"};